import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, X } from 'lucide-react';

/**
 * Full-screen modal shown to guests after using their one free invoice.
 *
 * Props:
 *   onClose — called when the user dismisses (maybe-later). Pass null to hide the button.
 */
export default function SignUpGate({ onClose }) {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
        {/* Close button — only shown when caller provides onClose */}
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        )}

        {/* Icon */}
        <div className="flex items-center justify-center w-14 h-14 bg-blue-50 rounded-2xl mb-5 mx-auto">
          <FileText className="w-7 h-7 text-blue-600" />
        </div>

        <h2 className="text-xl font-semibold text-gray-900 text-center mb-2">
          You've used your free invoice
        </h2>
        <p className="text-sm text-gray-500 text-center mb-6">
          Create a free account to generate unlimited invoices, access your history,
          and download PDFs anytime.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/auth')}
            className="w-full py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            Create free account
          </button>

          {onClose && (
            <button
              onClick={onClose}
              className="w-full py-2.5 text-gray-500 font-medium rounded-lg hover:bg-gray-50 transition-colors"
            >
              Maybe later
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
